import { getGoodsType } from "@/api";

const state = {
  // 后台“价格”类型整棵树（包含子：价格单位 / 价格汇率）
  priceUnitTree: null,
  // 子节点：价格单位
  priceUnitCNY: null,
  // 子节点：价格汇率
  priceUnitUSD: null,
  loaded: false,
};

const mutations = {
  SET_PRICE_UNIT_TREE(state, obj) {
    state.priceUnitTree = obj || null;
  },
  SET_PRICE_UNIT_CNY(state, obj) {
    state.priceUnitCNY = obj || null;
  },
  SET_PRICE_UNIT_USD(state, obj) {
    state.priceUnitUSD = obj || null;
  },
  SET_PRICE_UNIT_LOADED(state, flag) {
    state.loaded = flag;
  },
};

const actions = {
  // async loadPriceConfig({ state, commit }) {
  //   if (state.loaded) return;
  //   const res = await getGoodsType({ name: "价格" });
  //   if (res && res.code === 200 && Array.isArray(res.data) && res.data.length) {
  //     const priceUnitTree = res.data[0] || {};
  //     const children = Array.isArray(priceUnitTree.children)
  //       ? priceUnitTree.children
  //       : [];

  //     // 按名称或编码粗略拆分出“价格单位”和“价格汇率”两个子节点
  //     const priceUnitCNY = children.find((c) => c.name === "价格单位") || null;

  //     const priceUnitUSD = children.find((c) => c.name === "价格汇率") || null;

  //     commit("SET_PRICE_TREE", priceUnitTree);
  //     commit("SET_PRICE_UNIT_NODE", priceUnitCNY);
  //     commit("SET_PRICE_RATE_NODE", priceUnitUSD);
  //   }
  //   commit("SET_PRICE_LOADED", true);
  // },
  // 只在第一次调用时请求一次“价格”类型，后面直接用缓存
  async loadPriceUnitConfig({ state, commit }) {
    // 已加载则直接返回，避免重复请求
    if (state.loaded) return;

    // 定义 value 映射规则（可根据需求灵活修改）
    // 格式：{ 匹配的number值: 对应的value值 }，未匹配到的默认值设为 "1"
    const valueMap = {
      CNY: 0,
      USD: 10,
      EUR: 20, // 可扩展其他币种
    };
    // 默认 value 值（未匹配到映射规则时使用）
    const defaultValue = 1;

    try {
      const res = await getGoodsType({ name: "价格单位" });
      if (
        res &&
        res.code === 200 &&
        Array.isArray(res.data) &&
        res.data.length
      ) {
        const priceUnitTree = res.data[0] || {};
        // 先校验 children 是否为数组，兜底为空数组
        const children = Array.isArray(priceUnitTree.children)
          ? priceUnitTree.children
          : [];

        // ========== 核心修改：直接给 children 原对象新增 value 属性 ==========
        // 遍历 children，给每个对象新增 value（修改原结构）
        children.forEach((item) => {
          // 先判断 valueMap 中是否有该 number 对应的键（无论值是 0/''/false 都算匹配）
          const hasMatch = valueMap.hasOwnProperty(item.number);
          // 有匹配则取映射值，无匹配则用默认值
          item.value = hasMatch ? valueMap[item.number] : defaultValue;
        });

        // ========== 后续逻辑：基于修改后的原结构取值 ==========
        // 此时 children 已包含 value 属性，find 出来的对象直接带 value
        const CNY = children.find((c) => c.number === "CNY") || null;
        const USD = children.find((c) => c.number === "USD") || null;

        // 提交 mutation 时，priceUnitTree 的 children 已包含新增的 value
        commit("SET_PRICE_UNIT_TREE", priceUnitTree);
        commit("SET_PRICE_UNIT_CNY", CNY);
        commit("SET_PRICE_UNIT_USD", USD);
        commit("SET_PRICE_UNIT_LOADED", true);
      }
    } catch (error) {
      // 捕获异常，避免请求失败导致后续逻辑阻塞（Vue2 项目建议加错误捕获）
      console.error("加载价格单位配置失败：", error);
    }
  },
};

const getters = {
  priceUnitTree: (state) => state.priceUnitTree,
  priceUnitCNY: (state) => state.priceUnitCNY,
  priceUnitUSD: (state) => state.priceUnitUSD,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
